import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)({
  maxWidth: "300px",
  display: "flex",
  flexDirection: "column",
});

export const formFieldStyles = {
  width: "100%",
  margin: "10px 0",
};

export const DocumentsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  gap: "10px",
  alignItems: "center",
});

export const DocumentsBlock = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  flexWrap: "wrap",
  minWidth: "100%",
});
